import "./IconAlert.scss";

export const IconAlert = ({ iconStyle = "outline" }: { iconStyle?: "outline" | "filled" }) => {
  return iconStyle === "outline" ? (
    <span className="icon-alert"></span>
  ) : (
    <span className="icon-alert--filled">
      <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.5 0.5C8.9375 0.5 9.34375 0.75 9.5625 1.125L16.3125 12.625C16.5312 13.0312 16.5312 13.5 16.3125 13.875C16.0938 14.2812 15.6875 14.5 15.25 14.5H1.75C1.28125 14.5 0.875 14.2812 0.65625 13.875C0.4375 13.5 0.4375 13.0312 0.65625 12.625L7.40625 1.125C7.625 0.75 8.03125 0.5 8.5 0.5ZM8.5 4.5C8.0625 4.5 7.75 4.84375 7.75 5.25V8.75C7.75 9.1875 8.0625 9.5 8.5 9.5C8.90625 9.5 9.25 9.1875 9.25 8.75V5.25C9.25 4.84375 8.90625 4.5 8.5 4.5ZM9.5 11.5C9.5 10.9688 9.03125 10.5 8.5 10.5C7.9375 10.5 7.5 10.9688 7.5 11.5C7.5 12.0625 7.9375 12.5 8.5 12.5C9.03125 12.5 9.5 12.0625 9.5 11.5Z"
          fill="#A66400"
        />
      </svg>
    </span>
  );
};
